<template>
    <spinner v-if="isLoading"></spinner>

    <div class="container-fluid">
        <div class="row">
            <div class="1st-page" style="opacity: 1">
                <div class="align-items-stretch col-12 d-flex dashboard-wrap flex-wrap p-0" style="z-index: 9999;">
                    <div class="vstack">
                        <!-- <div class="hstack justify-content-between position-absolute top-line">
                            <div class="logo-box hstack justify-content-between">
                                <div class="back-arrow">
                                    <a :href="'/boards/doska-to'">
                                        <span class="material-symbols-outlined">arrow_back_ios</span>
                                    </a>
                                </div>
                            </div>
                        </div> -->
                        <div class="justify-content-between p-0 page vstack" style="border-radius: 0;">

                            <!-- Slider #1 Start -->
                            <div class="slider" style="height: 785px;">
                                <!-- Если есть хотя бы одна картинка -->
                                <Carousel v-if="slider_1.length" :slides="slider_1" :delay="5000"
                                    style="height: 100%;" />
                                <!-- Иначе — заглушка -->
                                <img v-else src="https://dummyimage.com/2160x785/ccc/fff.jpg&text=Slider+1+-+2160x785"
                                    alt="Заглушка слайдера" style="width:100%; height:100%; object-fit:cover;" />
                            </div>
                            <!-- Slider #1 End -->

                            <!-- Table Start -->
                            <div class="prices h-100">
                                <table class="table table-bordered h-100">
                                    <thead>
                                        <tr>
                                            <th scope="col">Пробег, тыс. км</th>
                                            <th scope="col">10</th>
                                            <th scope="col">20</th>
                                            <th scope="col">30</th>
                                            <th scope="col">40</th>
                                            <th scope="col">50</th>
                                            <th scope="col">60</th>
                                            <th scope="col">70</th>
                                            <th scope="col">80</th>
                                            <th scope="col">90</th>
                                            <th scope="col">100</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(prices, model) in items" :key="model">
                                            <td>{{ model }}</td>
                                            <td v-for="km in kms" :key="km">
                                                {{ formatPrice(prices[km]) }}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <!-- Table End -->

                            <!-- Slider #2 Start -->
                            <div class="slider" style="height: 785px;">
                                <Carousel v-if="slider_2.length" :slides="slider_2" style="height: 100%;" />
                                <img v-else src="https://dummyimage.com/2160x785/ccc/fff.jpg&text=Slider+2+-+2160x785"
                                    alt="Заглушка слайдера" style="width:100%; height:100%; object-fit:cover;" />
                            </div>
                            <!-- Slider #2 End -->

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Spinner from "../../../components/Spinner.vue";

import * as req from "../../../services/boards";
import Carousel from './Carousel.vue';

export default {
    components: { Spinner, Carousel },
    name: "Display",
    data() {
        return {
            isLoading: false,
            items: [],
            cars: [],
            boardId: 2,
            slider_1: [],
            slider_2: [],
            kms: [10000,20000,30000,40000,50000,60000,70000,80000,90000,100000]
        }
    },
    mounted() {
        this.getSliderData();
        window.Echo
            .channel('update-slider')
            .listen('SliderImagesUpdated', () => {
                // при любом обновлении картинок — перезагрузим оба слайдера
                this.getSliderData();
            });
        window.Echo
            .channel('board-updates')
            .listen('BoardUpdated', () => {
                this.getData();
            });
        this.getData();
    },
    methods: {
        formatPrice(value) {
            if (!value) return '—';
            return new Intl.NumberFormat('ru-RU').format(value);
        },
        async getData() {
            this.isLoading = true;
            try {
                const data = await req.getTOBoards();
                this.items = data;
            } catch (e) {
                console.error("Ошибка загрузки прайса ТО:", e);
            } finally {
                this.isLoading = false;
            }
        },
        async getSliderData() {
            this.isLoading = true;
            try {
                const allImages = await req.getAllSliderImages(this.boardId);
                this.slider_1 = allImages.slider_1;
                this.slider_2 = allImages.slider_2;
            } catch (e) {
                console.error("Ошибка загрузки картинок слайдеров:", e);
            } finally {
                this.isLoading = false;
            }
        }
    }
}
</script>

<style scoped>
.prices {
    border-top: 10px solid #c00;
    border-bottom: 10px solid #c00;
    background-color: #222;
}

.prices table {
    color: #fff;
    font-size: 39px;
    font-weight: bold;
    text-wrap: nowrap;
    text-align: center;
}

thead {
    background-color: #fff;
    color: #222;
    font-size: 57px;
    line-height: 140px;
}

thead tr th:first-child {
    text-align: left;
    font-size: 40px;
    font-weight: normal;
    padding-left: 30px;
}

tbody {
    background: url('/image/to_board_bg.jpg') no-repeat center center / cover #222;
}

tbody tr td {
    line-height: 113px;
}

tbody tr td:first-child {
    text-align: left;
    padding-left: 30px;
}
</style>
